module.exports = __webpack_public_path__ + "assets/baa7e91c83b3b78bebdb14fe11c9be75.mp3";